import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import VisibilityIcon from '@mui/icons-material/Visibility';
import Dialog from '@mui/material/Dialog';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, updateData, updateRouteNumber } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import SearchIcon from '@mui/icons-material/Search';
import Button from '@mui/material/Button';
import AddIcon from '@mui/icons-material/Add';
import { Tooltip } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save'; // Import the Save icon
import EditNoteIcon from '@mui/icons-material/EditNote';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CircularProgress from '@mui/material/CircularProgress';
import RefreshIcon from '@mui/icons-material/Refresh';
import Stack from '@mui/material/Stack';
import HistoryIcon from '@mui/icons-material/History';
//import { makeStyles } from '@mui/styles';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import CancelIcon from '@mui/icons-material/Cancel';
import Select from 'react-select';


function AddtionalOrderIndex() {


    //const classes = useStyles();
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [editedRouteSequenceNo, setEditedRouteSequenceNo] = useState(null);
    const [editItemId, setEditItemId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); // Change this number according to your preference

    // const { isAuthenticated, companyId, userId, logout, token } = useAuth();
    const [formData, setFormData] = useState();
    const { isAuthenticated, companyId, userId, permissions, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');

    // Define useStyles hook



    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchAddtionals();
    }, [isAuthenticated, companyId, token, logout]);

    const [routeOptions, setRouteOptions] = useState([]);
    const [selectedRoute, setSelectedRoute] = useState(null);

    const tripid = id;
    const fetchAddtionals = async () => {
        try {
            const response = await fetchData('AdditionalOrderIndex', `/${companyId}/${id}`, token);

            if (response.responseCode === '1111') {
                console.log(response);
                setData(response.response_data);
            } else {
                console.error('Unexpected response code:', response.responseCode);
            }
        } catch (error) {
            if (error.response && error.response.status === 404) {
                console.error('API not found (404). Check the endpoint:', error.response);
            } else {
                console.error('Error fetching order details:', error);
            }
        }
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }

    return (
        <div style={{ maxWidth: '100%', padding: '16px', backgroundColor: '#f0f7f4', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)', margin: '20px auto' }}>
            
            {/* Header Section */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '16px', paddingBottom: '12px', borderBottom: '2px solid #6b4c7a' }}>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: 'bold', color: '#6b4c7a', fontFamily: 'Arial, sans-serif', textTransform: 'uppercase' }}>
                    Additional Order List
                </h2>
                {hasCreateMasterPermission && (
                    <Link to={`/AdditionalOrderCreate/${id}`} style={{ textDecoration: 'none' }}>
                        <Tooltip title="Create Additional Order">
                            <Button 
                                variant="contained"
                                style={{ 
                                    height: '36px',
                                    fontSize: '12px',
                                    backgroundColor: '#10a37f',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    borderRadius: '18px',
                                    textTransform: 'none',
                                    padding: '0 20px'
                                }}
                            >
                                <AddIcon style={{ fontSize: '18px', marginRight: '4px' }} />
                                Create
                            </Button>
                        </Tooltip>
                    </Link>
                )}
            </div>

            {/* Table Section */}
            <div style={{ maxHeight: '600px', overflowY: 'auto', borderRadius: '8px', boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)' }}>
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead style={{ position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#6b4c7a' }}>
                            <TableRow>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Customer Name</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Contact Number</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Trip Description</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', borderRight: '1px solid rgba(255, 255, 255, 0.2)' }}>Route Name</TableCell>
                                <TableCell style={{ color: 'white', fontWeight: 700, fontSize: '11px', padding: '8px 6px', textAlign: 'center' }}>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {data && data.length > 0 ? (
                                data.map((item, index) => (
                                    <TableRow 
                                        key={item.id} 
                                        style={{ 
                                            backgroundColor: index % 2 === 0 ? '#f8f9fa' : 'white',
                                            borderBottom: '1px solid #dee2e6'
                                        }}
                                    >
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.customerName} {item.addressLine1}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.phone}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.tripdetails}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', color: '#2c3e50', borderRight: '1px solid #dee2e6' }}>
                                            {item.rName}
                                        </TableCell>
                                        <TableCell style={{ fontSize: '11px', padding: '6px', textAlign: 'center' }}>
                                            {hasEditMasterPermission && (
                                                <Link to={`/AdditionalOrderEdit/${item.id}`}>
                                                    <Tooltip title="Edit Additional Order">
                                                        <IconButton size="small">
                                                            <EditIcon style={{ color: '#6b4c7a', fontSize: '18px' }} />
                                                        </IconButton>
                                                    </Tooltip>
                                                </Link>
                                            )}
                                        </TableCell>
                                    </TableRow>
                                ))
                            ) : (
                                <TableRow>
                                    <TableCell colSpan={5} style={{ textAlign: 'center', padding: '40px', color: '#6c757d', fontSize: '14px' }}>
                                        No additional orders found
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        </div>
    );
}

export default AddtionalOrderIndex;
